import { render } from "./show-achievement.vue?vue&type=template&id=7b72ec70&scoped=true"
import script from "./show-achievement.vue?vue&type=script&lang=js"
export * from "./show-achievement.vue?vue&type=script&lang=js"

import "./show-achievement.vue?vue&type=style&index=0&id=7b72ec70&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b72ec70"]])

export default __exports__